export default {
  'giftCardReport.title': '礼品卡报表',
  'giftCardReport.tabs.restaurantGroup': '连锁集团',
  'giftCardReport.tabs.restaurant': '单店',
  'giftCardReport.subTitle': '礼品卡的余额和交易记录',
  'giftCardReport.filter.search': '搜索',
  'giftCardReport.search.placeholder': '查询卡号',
  'giftCardReport.action.clear': '清除',

  'giftCardReport.field.cardType': '卡类型',
  'giftCardReport.field.cardNumber': '卡号',
  'giftCardReport.field.issueTime': '发卡时间',
  'giftCardReport.field.initialBalance': '初始金额',
  'giftCardReport.field.currentBalance': '当前余额',
  'giftCardReport.field.totalSpending': '总消费',
  'giftCardReport.field.lastUpdate': '上次更新',
  'giftCardReport.field.status': '状态',
  'giftCardReport.field.issuer': '发卡人',

  'giftCardReport.detail.title': '礼品卡',

  'giftCardReport.transaction.field.time': '时间',
  'giftCardReport.transaction.field.type': '交易类型',
  'giftCardReport.transaction.field.staff': '员工',
  'giftCardReport.transaction.field.purchaseAmount': '交易金额',
  'giftCardReport.transaction.field.bonusAmount': '充返金额',
  'giftCardReport.transaction.field.balance': '余额',
  'giftCardReport.transaction.field.paymentType': '支付方式',
  'giftCardReport.transaction.field.paymentTotal': '支付合计',
  'giftCardReport.transaction.field.orderNumber': '订单#',
  'giftCardReport.giftCard.action.suspend': '暂停使用',
  'giftCardReport.giftCard.action.active': '恢复使用',
  'giftCardReport.giftCard.action.delete': '删除账户',

  'giftCardReport.giftCard.action.suspend.title': '确认要暂停礼品卡使用吗？',
  'giftCardReport.giftCard.action.suspend.confirmCotennt': '暂停使用的礼品卡不能用于消费',
  'giftCardReport.giftCard.action.suspend.comfirm': '是的，暂停',
  'giftCardReport.giftCard.action.suspend.cancel': '取消',

  'giftCardReport.giftCard.action.delete.title': '确定要删除礼品卡账户吗？',
  'giftCardReport.giftCard.action.delete.confirmCotennt': '所有关于本礼品卡的记录会被删除',
  'giftCardReport.giftCard.action.delete.comfirm': '确定，删除',
  'giftCardReport.giftCard.action.delete.cancel': '取消',

  'giftCardReport.giftCard.action.active.title': '确认要恢复礼品卡使用吗？',
  'giftCardReport.giftCard.action.active.confirmCotennt': '',
  'giftCardReport.giftCard.action.active.comfirm': '是的，恢复',
  'giftCardReport.giftCard.action.active.cancel': '取消',

  'giftCardReport.giftCard.suspend.success': '暂停礼品卡成功',
  'giftCardReport.giftCard.suspend.failed': '暂停礼品卡失败',

  'giftCardReport.giftCard.active.success': '恢复礼品卡成功',
  'giftCardReport.giftCard.active.failed': '恢复礼品卡失败',

  'giftCardReport.giftCard.delete.success': '删除礼品卡账户成功',
  'giftCardReport.giftCard.delete.failed': '删除礼品卡账户失败',

  'giftCardReport.detail.cardsection.cardinfo': '卡信息',
  'giftCardReport.detail.cardsection.note': '备注',
  'giftCardReport.detail.cardsection.transactions': '交易记录',
  'giftCardReport.detail.cardsection.note.action': '编辑',

  'giftCardReport.topup.field.issueTime': '时间',
  'giftCardReport.topup.field.cardNumber': '卡号',
  'giftCardReport.topup.field.transcationType': '交易类型',
  'giftCardReport.topup.field.staff': '员工',
  'giftCardReport.topup.field.purchaseAmount': '交易金额',
  'giftCardReport.topup.field.bonusAmount': '充返金额',
  'giftCardReport.topup.field.currentBalance': '余额',
  'giftCardReport.topup.field.paymentType': '支付方式',
  'giftCardReport.topup.field.paymentTotalAmount': '支付合计',
  'giftCardReport.topup.field.orderNumber': '订单#',
};
